type LastVisitedContent = {
  id: string;
  url: string;
};

export const getLastVisitedContentUrl = (): string => {
  try {
    const lastVisitedContentString = localStorage.getItem('lastVisitedContent');
    if (lastVisitedContentString) {
      const lastVisitedContent = JSON.parse(lastVisitedContentString) as LastVisitedContent;
      return lastVisitedContent.url || '';
    }
  } catch (error) {
    console.error('Error parsing last visited content:', error);
  }
  return '';
};
